/* eslint-disable no-console */
import { DEV, LOG_ALL, TEST, STAGE } from '../constants';
import noop from './noop';

export const ENABLE_LOGGING = TEST || DEV || STAGE || LOG_ALL;

export const error =
  ENABLE_LOGGING && console && console.error
    ? console.error.bind(console)
    : noop;
export const info =
  ENABLE_LOGGING && console && console.info ? console.info.bind(console) : noop;
export const debug =
  ENABLE_LOGGING && console && console.debug
    ? console.debug.bind(console)
    : noop;
export const log =
  ENABLE_LOGGING && console && console.log ? console.log.bind(console) : noop;
export const table =
  ENABLE_LOGGING && console && console.table
    ? console.table.bind(console)
    : noop;
export const warn =
  ENABLE_LOGGING && console && console.warn ? console.warn.bind(console) : noop;
